import { Base } from '../base-component';
import { AnalyticsService } from '../../services/analytics.service';

import './video-carousel-item.component.scss';

import * as $ from 'jquery';

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

export class VideoCarouselItem extends Base {

	playButton: HTMLElement;
	closeButton: HTMLElement;
	playerContainer: HTMLElement;
	playerContent: HTMLElement;
	playerTimeContainer: HTMLElement;
	isExternal: boolean;
	time: any;
	player: any;
	video: any;

	constructor(element: Element){
		super(element);
	}

	init(){

		this.playButton = this.element.querySelector('.js-video-play') as HTMLElement;
		this.closeButton = this.element.querySelector('.js-video-close') as HTMLElement;
		this.playerContainer = this.element.querySelector('.video-carousel-item__container') as HTMLElement;
		this.playerContent = this.element.querySelector('.video-carousel-item__playercontent') as HTMLElement;
		this.playerTimeContainer = this.element.querySelector('.video-carousel-item__time-placeholder') as HTMLElement;
		this.player = this.playerContainer.querySelector('.ot-video-containingBlock');
		this.video = this.element.querySelector('video');		
		this.isExternal = false;

	}

	bindEvents() {

		this.playButton.addEventListener('click', (event) => this.showVideo(event));
		this.closeButton.addEventListener('click', (event) => this.hideVideo(event));
		this.renderTime();

	}

	showVideo(event) {

		event.preventDefault;
		this.hideActiveVideo(event);
		this.playerContainer.classList.add('video-carousel-item__container--playing');
		if(event.currentTarget.hasAttribute('data-youtube-id')){
			this.isExternal = true;
			let videoExternal = event.currentTarget;
			let getVideo = videoExternal.getAttribute('data-youtube-id');
			this.createIframePlayer(getVideo);
			this.analyticsService.dtmVideoTrackerAutoSpot();
		}else{			
			this.video.player.play();
		}

	}

	hideVideo(event) {

		event.preventDefault;
		let removeIframe = this.playerContent.querySelector('iframe');
		this.playerContainer.classList.remove('video-carousel-item__container--playing');
		if(removeIframe){
			this.playerContent.removeChild(removeIframe); 
		}else{
			this.video.player.pause();
		}
		
	}

	hideActiveVideo(event){
		
		let selectedVideo: any = event.target;
		
		if(!selectedVideo.classList.contains('video-carousel-item__container--playing')){

			let videoContainers: any = Array.from(document.querySelectorAll('.video-carousel-item__container--playing'));

			videoContainers.map((itemContainer) => {
				itemContainer.classList.remove('video-carousel-item__container--playing');
				let iframeExistence: any = itemContainer.querySelector('iframe');
				if(iframeExistence){
					let iframeChildren = $(itemContainer).find('iframe');
					iframeChildren.remove();
				}else{
					let videoChildren: any = itemContainer.querySelector('video');
					let playerChildren: any = itemContainer.querySelector('.ot-video-containingBlock');
					videoChildren.pause();
				}
			});
						
		}

	}

	createIframePlayer(url: any){

		let externalUrl = 'https://www.youtube.com/embed/';
		externalUrl += url;
		externalUrl += '?rel=0&amp;showinfo=0&enablejsapi=1';
		let createIframe = document.createElement('iframe');
		createIframe.id = 'video__external';
		createIframe.src = externalUrl;
		createIframe.classList.add('video__iframe');
		this.playerContent.appendChild(createIframe);

	}

	renderTime(){

		if(this.playButton.hasAttribute('data-youtube-id')){

			let videoTimePlaceholder: any = this.playerTimeContainer;
			let getVideo = this.playButton.getAttribute('data-youtube-id');

			axios.get('https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id='+getVideo+'&key=AIzaSyBcaoVc-sCwi_7txKMV9BEUhDf4yrcq384', { responseType: 'json' }).then(function(response: any) {

				let object: any = response.data.items[0].contentDetails.duration;
				let array: any = object.match(/(\d+)(?=[MHS])/ig)||[]; 
				let formatted: any = array.map(function(item){
					if(item.length<2) return '0'+item;
					return item;
				}).join(':');

				if(formatted){
					videoTimePlaceholder.innerHTML = formatted;
				}else{
					videoTimePlaceholder.innerHTML = '00:00:00';
				}

			}).catch(function(response) {
				console.log(response);
			});

		}

	}

}



// WEBPACK FOOTER //
// ./components/video-carousel-item/video-carousel-item.component.ts